import c from "../common"

export default {

    //Column
    "ApplicationNumber": "申請編號",
    "ShopID": "商店ID",

    "VendorName": "品牌名稱",
    "VendorPhone": "電話",
    "TicketName": "劵名稱",

    "isGroupAdmin":"總店", 
    "Progress":"進度", 

    "Processing":"審核中",
    "Approved": "已批核",
    "Reject": "已拒絕",
    "Cancelled": "已取消",
    "Expired": "已過期",

    "NeedResubmit":"需要修改,並重新提交",

    "LastEdit":"最後修改時間",

    "ApplicationList":"申請列表",

    "Detail": "查看",

    "LogOut": "登出",

    "issueRequest": "發行新劵",
    "updateRequest": "更改資料",

};